var map = {
	"./atlas.png": 32,
	"./bg_day.png": 33,
	"./bg_night.png": 34,
	"./bird0_0.png": 35,
	"./bird0_1.png": 36,
	"./bird0_2.png": 37,
	"./bird1_0.png": 38,
	"./bird1_1.png": 39,
	"./bird1_2.png": 40,
	"./bird2_0.png": 41,
	"./bird2_1.png": 42,
	"./bird2_2.png": 43,
	"./black.png": 44,
	"./blink_00.png": 45,
	"./blink_01.png": 46,
	"./blink_02.png": 47,
	"./brand_copyright.png": 48,
	"./button_menu.png": 49,
	"./button_ok.png": 50,
	"./button_pause.png": 51,
	"./button_play.png": 52,
	"./button_rate.png": 53,
	"./button_restart.png": 54,
	"./button_resume.png": 55,
	"./button_score.png": 56,
	"./button_share.png": 57,
	"./font_048.png": 58,
	"./font_049.png": 59,
	"./font_050.png": 60,
	"./font_051.png": 61,
	"./font_052.png": 62,
	"./font_053.png": 63,
	"./font_054.png": 64,
	"./font_055.png": 65,
	"./font_056.png": 66,
	"./font_057.png": 67,
	"./land.png": 68,
	"./medals_0.png": 69,
	"./medals_1.png": 70,
	"./medals_2.png": 71,
	"./medals_3.png": 72,
	"./new.png": 73,
	"./number_context_00.png": 74,
	"./number_context_01.png": 75,
	"./number_context_02.png": 76,
	"./number_context_03.png": 77,
	"./number_context_04.png": 78,
	"./number_context_05.png": 79,
	"./number_context_06.png": 80,
	"./number_context_07.png": 81,
	"./number_context_08.png": 82,
	"./number_context_09.png": 83,
	"./number_context_10.png": 84,
	"./number_score_00.png": 85,
	"./number_score_01.png": 86,
	"./number_score_02.png": 87,
	"./number_score_03.png": 88,
	"./number_score_04.png": 89,
	"./number_score_05.png": 90,
	"./number_score_06.png": 91,
	"./number_score_07.png": 92,
	"./number_score_08.png": 93,
	"./number_score_09.png": 94,
	"./pipe2_down.png": 95,
	"./pipe2_up.png": 96,
	"./pipe_down.png": 97,
	"./pipe_up.png": 98,
	"./score_panel.png": 99,
	"./score_panel_2.png": 100,
	"./text_game_over.png": 101,
	"./text_ready.png": 102,
	"./title.png": 103,
	"./tutorial.png": 104,
	"./white.png": 105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;